export default __webpack_public_path__ + "static/media/reschedule-group-green-time.ebd2d66b.svg";